import React, { useMemo, useState } from 'react'
import Text from '../text/Text'
import { format } from 'date-fns'
import { currencyFormat, parseStringDate } from '../../formatters'
import styles from './../saleComponent/SaleComponent.module.css'
import ModalComponent from '../modal/ModalComponent'
import { labels } from '../../labels'
import { Token, TransactionResponse } from '../../services/commerce'
import { getTokenName } from '../saleComponent/SaleComponent'

import {
    anularVenta,
    reverseBciPayment,
    reverseCashPayment,
    reverseGetnetPayment,
    reversePOSManualPayment,
} from '../../services/payment'
import { capitalizeFirstLetter } from '../../utils'
import { getLocal } from '../../Utils/Profile'
import { ReceiptModalDetail } from './DetailSaleModal'
import iconAlert from '../../assets/icons/warning-yellow-ilus.svg'
import check from '../../assets/icons/check.png'

interface IModalInfoProps {
    title: string
    label: string
    customColor?: string
    customContainerClassName?: string
    isBCItx?: boolean
}

interface ISaleModalComponentProps {
    open: boolean
    handleClose: () => void
    sale: TransactionResponse
    tokens: Token[] | null
    handlerRefresh?: () => void
    reverseState: ReverseModalState
    updateReverseState: (newState: ReverseModalState) => void
}

export enum ReverseModalState {
    Inicial = 'Inicial',
    Enviada = 'Enviada',
    Rechazada = 'Rechazada',
    ErrorBCI = 'Error',
    Loading = 'Loading',
    Timeout = 'Timeout',
    TxNulled = 'ANULADA',
}

const truncateText = (text: string, maxLength = 20) => {
    if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...'
    }
    return text
}

const ModalInfo = ({
    title,
    label,
    customColor,
    customContainerClassName,
    isBCItx,
}: IModalInfoProps) => {
    return (
        <div className={styles.modalRow}>
            <p className={`${styles.modalContentText} ${styles.gray}`}>
                <div>
                    <Text
                        label={truncateText(title)}
                        fontSize={16}
                        color={'#656565'}
                        fontFamily={'Montserrat'}
                        fontWeight={400}
                    />
                </div>
            </p>
            {isBCItx ? (
                <div
                    className={`${styles.descriptionText}  ${customContainerClassName}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigator.clipboard.writeText(label)}
                >
                    <Text
                        label={truncateText(label)}
                        fontSize={16}
                        color={'#464646'}
                        fontFamily={'Montserrat'}
                        fontWeight={600}
                    />
                </div>
            ) : (
                <div
                    className={`${styles.descriptionText} ${customContainerClassName}`}
                >
                    <Text
                        label={truncateText(label)}
                        fontSize={16}
                        color={'#464646'}
                        fontFamily={'Montserrat'}
                        fontWeight={600}
                        variant={customColor || styles.primary}
                    />
                </div>
            )}
        </div>
    )
}

export const dateFormat = 'dd/MM/yyyy - HH:mm'
export const amiRutToken = '3487990009'
export const codWebToken = '3487990005'
export const codAppToken = '3487990007'
export const qrToken = '3487990010'
export const bciToken = ''
export const getnetToken = ''

const SaleModalComponent = ({
    open,
    handleClose,
    sale,
    tokens,
    reverseState,
    updateReverseState,
    handlerRefresh,
}: ISaleModalComponentProps) => {
    const tokenName = useMemo(
        () => getTokenName(sale.sToken, tokens),
        [sale.sToken, tokens]
    )

    const [openReusableReverseModal, setOpenReusableReverseModal] =
        useState(false)
    const [openRetryModal, setOpenRetryModal] = useState(false)
    const [buyOrder, setBuyOrder] = useState('')
    const [showReceiptModal, setShowReceiptModal] = useState(false)

    const [showReverseWarningModal, setShowReverseWarningModal] =
        useState(false)
    const [showSuccessModalModal, setShowSuccessModalModal] = useState(false)

    const handleReverseRequest = async (tokenName: string) => {
        setShowReverseWarningModal(false)
        if (
            tokenName.toUpperCase() ===
            labels.posManualPayment.tokenName.toUpperCase()
        ) {
            const sLocal = getLocal()
            try {
                const resp = await reversePOSManualPayment(
                    sLocal,
                    sale.idTransaccion,
                    Number(sale.nMonto)
                )
                if (resp && resp.status === 200) {
                    handleCloseReusableReverseModal()
                    setShowReverseWarningModal(false)
                    setShowSuccessModalModal(true)
                }
                if (handlerRefresh) handlerRefresh()

                console.log('REVERSE POSMANUAL PAYMENT ', resp)
            } catch (e) {
                console.log('ERROR REVERSE POSMANUAL PAYMENT', e)
            }
            return
        }

        if (tokenName === labels.cashPayment.tokenName) {
            const idLocal = getLocal()

            try {
                const resp = await reverseCashPayment(
                    idLocal,
                    sale.idTransaccion,
                    Number(sale.nMonto)
                )
                if (resp && resp.status === 200) {
                    handleCloseReusableReverseModal()
                }
                if (handlerRefresh) handlerRefresh()

                console.log('REVERSE CASH PAYMENT ', resp)
            } catch (e) {
                console.log('ERROR REVERSE CASH PAYMENT', e)
            }
            return
        }

        if (tokenName.includes(labels.getnetPayment.getnet)) {
            try {
                updateReverseState(ReverseModalState.Loading)
                setOpenReusableReverseModal(true)

                const response = await reverseGetnetPayment(sale.idTransaccion)

                if (response && response.status) {
                    switch (response.status) {
                        case 'NULLED':
                            updateReverseState(ReverseModalState.Enviada)
                            if (handlerRefresh) handlerRefresh()
                            break
                        case 'REJECT':
                            setBuyOrder(response.buyOrder)
                            updateReverseState(ReverseModalState.Rechazada)
                            break
                        case 'ERROR':
                            updateReverseState(ReverseModalState.ErrorBCI)
                            break
                        case 'TIMEOUT':
                            updateReverseState(ReverseModalState.Timeout)
                            break
                        case 'PENDING_NULLED':
                            updateReverseState(ReverseModalState.Enviada)
                            break
                        default:
                            updateReverseState(ReverseModalState.ErrorBCI)
                    }
                } else {
                    setOpenRetryModal(true)
                    updateReverseState(ReverseModalState.Inicial)
                }
            } catch (error) {
                console.error('Fallo en la anulación:', error)
            }
        } else if (tokenName.includes(labels.bciPayment.bci)) {
            try {
                updateReverseState(ReverseModalState.Loading)
                setOpenReusableReverseModal(true)

                const response = await reverseBciPayment(sale.idTransaccion)

                if (response && response.status) {
                    switch (response.status) {
                        case 'NULLED':
                            updateReverseState(ReverseModalState.Enviada)
                            if (handlerRefresh) handlerRefresh()
                            break
                        case 'REJECT':
                            setBuyOrder(response.buyOrder)
                            updateReverseState(ReverseModalState.Rechazada)
                            break
                        case 'ERROR':
                            updateReverseState(ReverseModalState.ErrorBCI)
                            break
                        case 'TIMEOUT':
                            updateReverseState(ReverseModalState.Timeout)
                            break
                        case 'PENDING_NULLED':
                            updateReverseState(ReverseModalState.Enviada)
                            break
                        default:
                            updateReverseState(ReverseModalState.ErrorBCI)
                    }
                } else {
                    setOpenRetryModal(true)
                    updateReverseState(ReverseModalState.Inicial)
                }
            } catch (error) {
                console.error('Fallo en la anulación:', error)
            }
        } else {
            try {
                updateReverseState(ReverseModalState.Loading)
                setOpenReusableReverseModal(true)

                const response = await anularVenta(sale.idTransaccion)

                if (response && response.status) {
                    switch (response.status) {
                        case 'NULLED':
                            updateReverseState(ReverseModalState.Enviada)
                            if (handlerRefresh) handlerRefresh()
                            break
                        case 'REJECT':
                            setBuyOrder(response.buyOrder)
                            updateReverseState(ReverseModalState.Rechazada)
                            break
                        case 'ERROR':
                            updateReverseState(ReverseModalState.ErrorBCI)
                            break
                        case 'TIMEOUT':
                            updateReverseState(ReverseModalState.Timeout)
                            break
                        case 'TX_NULLED':
                            updateReverseState(ReverseModalState.TxNulled)
                            if (handlerRefresh) handlerRefresh()
                            break
                        default:
                            updateReverseState(ReverseModalState.ErrorBCI)
                    }
                } else {
                    setOpenRetryModal(true)
                    updateReverseState(ReverseModalState.Inicial)
                }
            } catch (error) {
                console.error('Fallo en la anulación:', error)
            }
        }
    }

    const handleCloseReusableReverseModal = () => {
        setOpenReusableReverseModal(false)
    }

    const getModalBody = () => {
        switch (reverseState) {
            case ReverseModalState.Enviada:
                return <ReusableMessage label={labels.reverseRequestSent} />
            case ReverseModalState.Rechazada:
                return (
                    <ReusableMessage
                        label={
                            'Tu solicitud de anulación ' +
                            buyOrder +
                            ' ha sido rechazada. Para más información, contacta a soporte amipass'
                        }
                    />
                )
            case ReverseModalState.ErrorBCI:
                return (
                    <ReusableMessage label="Tu solicitud de anulación no pudo efectuarse. Debido a un error en el servicio." />
                )
            case ReverseModalState.Timeout:
                return (
                    <ReusableMessage label="Lo sentimos, no hemos podido enviar tu solicitud de anulación. Por favor inténtalo más tarde." />
                )
            case ReverseModalState.Loading:
                return (
                    <Text
                        label="Anulación en proceso ..."
                        fontSize={30}
                        fontWeight="bold"
                        color="#184287"
                        textAlign="center"
                        marginTop={40}
                    />
                )
            case ReverseModalState.TxNulled:
                return <ReusableMessage label="Anulada" />
            default:
                return null
        }
    }

    const getModalFooter = () => {
        if (reverseState === ReverseModalState.Enviada) {
            return (
                <div className={styles.modalRowButtons}>
                    <ReusableButton
                        label={labels.continueWithReverse}
                        onClick={() => setOpenReusableReverseModal(false)}
                        className={styles.buttonContinueWithReversal}
                    />
                </div>
            )
        } else if (reverseState === ReverseModalState.Loading) {
            return <></>
        } else {
            return (
                <div className={styles.modalRowButtons}>
                    <ReusableButton
                        label={labels.continue}
                        onClick={handleCloseReusableReverseModal}
                        className={styles.buttonContinue}
                    />
                </div>
            )
        }
    }

    const ReusableButton = ({
        label,
        onClick,
        className,
    }: {
        label: string
        onClick: () => void
        className: string
    }) => {
        return (
            <div className={styles.buttonContainerCenter}>
                <button className={className} onClick={onClick} type="button">
                    <Text
                        label={label}
                        fontWeight={600}
                        fontSize={13}
                        color="#fff"
                    />
                </button>
            </div>
        )
    }

    const ReusableMessage = ({
        label,
        value,
        fontSize = 16,
        color = 'red',
        textAlign = 'center',
        fontWeight = 'normal',
        marginTop = 10,
    }: {
        label: string
        value?: string | number
        fontSize?: number
        color?: string
        textAlign?: 'left' | 'right' | 'center'
        fontWeight?: 'normal' | 'bold'
        marginTop?: number
    }) => {
        return (
            <div className={styles.modalRow}>
                <Text
                    label={label}
                    fontSize={fontSize}
                    color={color}
                    textAlign={textAlign}
                    fontWeight={fontWeight}
                    marginTop={marginTop}
                    fontFamily={'Montserrat'}
                    marginBottom={10}
                />
                {value !== undefined && (
                    <div>
                        <Text
                            label={String(value)}
                            fontSize={16}
                            color={'#676767'}
                            fontWeight={600}
                            marginTop={10}
                            textAlign={'center'}
                            fontFamily={'Montserrat'}
                            marginBottom={10}
                        />
                    </div>
                )}
            </div>
        )
    }
    const handleReceiptButton = () => {
        setShowReceiptModal(true)
    }

    const reverseWarningModal = () => {
        return (
            <ModalComponent
                show={showReverseWarningModal}
                handleClose={() => setShowReverseWarningModal(false)}
                modalStyle={styles.modalReversePosPayment}
                titleMarginLeft={130}
            >
                <div className={styles.modalRowButtons}>
                    <img src={iconAlert} height={118} width={118} />
                </div>

                <Text
                    label="Está a punto de anular una venta"
                    fontWeight={600}
                    fontFamily={'Montserrat'}
                    fontSize={18}
                    color={'#565656'}
                    textAlign={'center'}
                    marginTop={36}
                    marginBottom={8}
                />
                <div className={styles.reverseModalTextSpan}>
                    <Text
                        label={`¿Está seguro que desea anular la\nventa N: `}
                        fontWeight={400}
                        fontFamily={'Montserrat'}
                        fontSize={18}
                        color={'#565656'}
                        textAlign={'center'}
                        marginTop={36}
                        marginBottom={8}
                        as="span"
                    />
                    <Text
                        label={
                            sale.authorizationCode &&
                            sale.authorizationCode.trim() !== '' &&
                            sale.authorizationCode.toLowerCase() !== 'null' &&
                            sale.authorizationCode.toLowerCase() !== 'undefined'
                                ? sale.authorizationCode
                                : sale.idTransaccion
                        }
                        fontWeight={700}
                        fontFamily={'Montserrat'}
                        fontSize={18}
                        color={'#565656'}
                        textAlign={'center'}
                        as="span"
                    />
                </div>
                <div
                    onClick={() => handleReverseRequest(tokenName)}
                    style={{
                        height: 72,
                        backgroundColor: '#E41B1B',
                        borderRadius: 14,
                        alignContent: 'center',
                        cursor: 'pointer',
                        marginTop: 17,
                    }}
                >
                    <Text
                        label={'Anular venta'}
                        fontFamily={'Montserrat'}
                        textAlign={'center'}
                        fontSize={16}
                        fontWeight={600}
                        color={'white'}
                    />
                </div>
            </ModalComponent>
        )
    }

    const reverseSuccessModal = () => {
        return (
            <ModalComponent
                show={showSuccessModalModal}
                handleClose={() => setShowSuccessModalModal(false)}
                modalStyle={styles.modalReversePosPayment}
                titleMarginLeft={130}
                icon={false}
            >
                <div className={styles.modalRowButtons}>
                    <img
                        src={check}
                        height={120}
                        width={120}
                        style={{ marginBottom: 30, marginTop: 16 }}
                    />
                </div>

                <div className={styles.reverseModalTextSpan}>
                    <Text
                        label={`La venta `}
                        fontWeight={400}
                        fontFamily={'Montserrat'}
                        fontSize={18}
                        color={'#565656'}
                        textAlign={'center'}
                        marginBottom={8}
                        as="span"
                    />
                    <Text
                        label={
                            sale.authorizationCode &&
                            sale.authorizationCode.trim() !== '' &&
                            sale.authorizationCode.toLowerCase() !== 'null' &&
                            sale.authorizationCode.toLowerCase() !== 'undefined'
                                ? sale.authorizationCode
                                : sale.idTransaccion
                        }
                        fontWeight={700}
                        fontFamily={'Montserrat'}
                        fontSize={18}
                        color={'#565656'}
                        textAlign={'center'}
                        as="span"
                    />
                    <Text
                        label={` fue anulada exitosamente`}
                        fontWeight={400}
                        fontFamily={'Montserrat'}
                        fontSize={18}
                        color={'#565656'}
                        textAlign={'center'}
                        marginTop={36}
                        marginBottom={8}
                        as="span"
                    />
                </div>
                <div
                    onClick={() => setShowSuccessModalModal(false)}
                    style={{
                        height: 56,
                        backgroundColor: '#0086D6',
                        borderRadius: 14,
                        alignContent: 'center',
                        cursor: 'pointer',
                        marginTop: 17,
                    }}
                >
                    <Text
                        label={'Cerrar ventana'}
                        fontFamily={'Montserrat'}
                        textAlign={'center'}
                        fontSize={16}
                        fontWeight={600}
                        color={'white'}
                    />
                </div>
            </ModalComponent>
        )
    }

    const isCash = sale.sToken === 'AMWEFEEFEEFE'
    return (
        <>
            <ModalComponent
                show={open}
                handleClose={handleClose}
                title={labels.saleDetail}
                modalStyle={styles.modalMain}
                titleMarginLeft={0}
                titleColor={'#184287'}
                fontFamily={'Montserrat'}
                fontSize={20}
            >
                <ReusableMessage
                    label={labels.paymentTotalAmount}
                    value={currencyFormat(parseFloat(sale.nMonto))}
                    color={
                        !isNaN(Number(sale.nMonto)) && Number(sale.nMonto) < 0
                            ? 'red'
                            : '#676767'
                    }
                />

                <Text
                    label={currencyFormat(
                        parseFloat(sale.nMonto) + parseFloat(sale.sTip)
                    )}
                    fontSize={36}
                    color={
                        !isNaN(Number(sale.nMonto)) && Number(sale.nMonto) < 0
                            ? 'red'
                            : '#0086D6'
                    }
                    textAlign="left"
                    fontWeight={'bold'}
                />
                <div className={styles.modalContent}>
                    <ModalInfo
                        title={
                            tokenName.includes('Efectivo')
                                ? labels.paymentTransactionN
                                : labels.paymentAuthorizationCode
                        }
                        label={
                            sale.authorizationCode &&
                            sale.authorizationCode.trim() !== '' &&
                            sale.authorizationCode.toLowerCase() !== 'null' &&
                            sale.authorizationCode.toLowerCase() !== 'undefined'
                                ? sale.authorizationCode
                                : sale.idTransaccion
                        }
                        isBCItx={
                            tokenName.includes(labels.bciPayment.bci) ||
                            tokenName.includes(labels.getnetPayment.getnet)
                        }
                    />
                    {sale.sTip === '0' && (
                        <ModalInfo
                            title={`${labels.saleClient}:`}
                            label={sale.sNombreCliente}
                        />
                    )}
                    <ModalInfo
                        title={labels.paymentDate}
                        label={format(
                            parseStringDate(sale.dTransaccion),
                            dateFormat
                        )}
                    />
                    <ModalInfo
                        title={labels.paymentMethodDetail}
                        label={
                            tokenName.includes(labels.bciPayment.bci)
                                ? 'POS BCI'
                                : tokenName.includes(
                                      labels.getnetPayment.getnet
                                  )
                                ? 'POS GETNET'
                                : tokenName
                        }
                    />
                    <ModalInfo
                        title={`${labels.saleStatus}:`}
                        label={capitalizeFirstLetter(sale.sEstadoTx)}
                        customColor={
                            [labels.canceled, labels.rejected].includes(
                                sale.sEstadoTx.toUpperCase()
                            )
                                ? styles.error
                                : styles.approved
                        }
                        customContainerClassName={
                            [labels.canceled, labels.rejected].includes(
                                sale.sEstadoTx.toUpperCase()
                            )
                                ? styles.errorContainer
                                : styles.approvedContainer
                        }
                    />
                </div>
                <div className={styles.modalRow} style={{ marginTop: 10 }}>
                    <div
                        style={{
                            justifyContent: 'center',
                            display: 'flex',
                            width: '100%',
                        }}
                    >
                        <button
                            onClick={handleReceiptButton}
                            type="button"
                            style={{
                                backgroundColor: '#0086D6',
                                height: 42,
                                width: 359,
                                borderRadius: 8,
                                cursor: 'pointer',
                            }}
                        >
                            <Text
                                label={'Ver comprobante'}
                                fontWeight={600}
                                fontSize={16}
                                color="#fff"
                                fontFamily={'Montserrat'}
                            />
                        </button>
                    </div>
                </div>
                {sale.sEstadoTx !== 'ANULADA' &&
                    sale.sEstadoTx !== 'PENDING_NULLED' &&
                    sale.sTipoTransaccion !== 'AN' && (
                        <>
                            {/* {sale.sToken === 'AMWEFEEFEEFE' && (
                                <div
                                    className={styles.modalRow}
                                    style={{ marginTop: 10 }}
                                >
                                    <div
                                        style={{
                                            justifyContent: 'center',
                                            display: 'flex',
                                            width: '100%',
                                        }}
                                    >
                                        <button
                                            onClick={handleReceiptButton}
                                            type="button"
                                            style={{
                                                backgroundColor: '#0086D6',
                                                height: 42,
                                                width: 359,
                                                borderRadius: 8,
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <Text
                                                label={'Ver comprobante'}
                                                fontWeight={600}
                                                fontSize={16}
                                                color="#fff"
                                                fontFamily={'Montserrat'}
                                            />
                                        </button>
                                    </div>
                                </div>
                            )} */}
                            <div
                                className={styles.modalRow}
                                style={{ marginTop: 10 }}
                            >
                                <div
                                    style={{
                                        justifyContent: 'center',
                                        display: 'flex',
                                        width: '100%',
                                    }}
                                >
                                    <button
                                        style={{
                                            backgroundColor: 'white',
                                            height: 42,
                                            width: 359,
                                            borderRadius: 8,
                                            border: '1px solid #D32F2F',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            setShowReverseWarningModal(true)
                                            handleClose()
                                            setOpenReusableReverseModal(false)
                                        }}
                                        type="button"
                                        disabled={
                                            reverseState ===
                                                ReverseModalState.Enviada ||
                                            sale.sEstadoTx === 'ANULADA' ||
                                            sale.sEstadoTx === 'PENDING_NULLED'
                                        }
                                    >
                                        <Text
                                            label={
                                                isCash
                                                    ? labels.cashPayment
                                                          .requestReverse
                                                    : labels.requestReverse
                                            }
                                            fontWeight={600}
                                            fontSize={16}
                                            color="#D32F2F"
                                            fontFamily={'Montserrat'}
                                        />
                                    </button>
                                </div>
                            </div>
                            {reverseState === ReverseModalState.Enviada && (
                                <div
                                    className={styles.modalRow}
                                    style={{ marginTop: 10 }}
                                >
                                    <Text
                                        label={labels.reverseRequested}
                                        fontSize={12}
                                        color="#FF3030"
                                        textAlign="center"
                                    />
                                </div>
                            )}
                        </>
                    )}
            </ModalComponent>

            {/* Modal retry */}
            <ModalComponent
                show={openRetryModal}
                handleClose={() => setOpenRetryModal(false)}
                title={labels.reverseRequest}
                modalStyle={styles.modalReverseRetry}
                titleMarginLeft={130}
                titleColor={'#184287'}
            >
                <div className={styles.modalRowButtons}>
                    <img
                        src={require('./../../assets/images/xsign.png')}
                        width={70}
                        style={{ marginTop: 20, marginBottom: 20 }}
                    />
                </div>

                <ReusableMessage
                    label={labels.sorryForBadReverse}
                    fontSize={20}
                    color="#676767"
                    textAlign="center"
                />

                <div className={styles.modalRowButtons}>
                    <div className={styles.buttonContainerCenter}>
                        <button
                            className={styles.buttonRetryReverse}
                            onClick={() => {
                                setOpenRetryModal(false)
                                handleReverseRequest(tokenName)
                            }}
                            type="button"
                        >
                            <Text
                                label={labels.retry}
                                fontWeight={600}
                                fontSize={24}
                                color="#565656"
                            />
                        </button>
                    </div>
                </div>
            </ModalComponent>

            {/* Modal anulacion dinámico */}
            <ModalComponent
                show={openReusableReverseModal}
                handleClose={handleCloseReusableReverseModal}
                title={labels.reverseRequest}
                modalStyle={styles.modalReverseRequestSent}
                titleMarginLeft={180}
                titleColor={'#184287'}
                icon={reverseState !== ReverseModalState.Loading}
            >
                {/* body dinámico */}
                {getModalBody()}

                {/* footer dinámico */}
                {getModalFooter()}
            </ModalComponent>
            <ReceiptModalDetail
                sale={sale}
                isOpen={showReceiptModal}
                onClose={() => setShowReceiptModal(false)}
            />
            {reverseWarningModal()}
            {reverseSuccessModal()}
        </>
    )
}

export default SaleModalComponent
